import firebase from '../../../fbConfig/fbConfig'


export const rep_rejectedPickups = async (inputs) => {
    var reportRes = {
        fields: ['#', 'Order ID', 'Order Placed Date', 'Customer Name', 'Telephone', 'City', 'Total Amount'],
        data: []
    };
    var beginningDateObject2 = new Date(inputs.dateRange.startDate);
    var beginningDateObject = new Date(inputs.dateRange.endDate);
    if (beginningDateObject2.getDate() == beginningDateObject.getDate()) {
        beginningDateObject.setHours(23);
        beginningDateObject.setMinutes(59);
        beginningDateObject.setSeconds(59);
    }
    const res = await firebase.firestore().collection('order').where('pickupDate', '>=', beginningDateObject2).where('pickupDate', '<', beginningDateObject).get()
    for (let a = 0; a < res.docs.length; a++) {
        if (res.docs[a].data().pickupRejected != undefined) {
            var d = res.docs[a].data().orderDate.toDate();
            reportRes.data.push({
                CO_Number: res.docs[a].data().generatedId,
                orderDate: d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear(),
                name: res.docs[a].data().name,
                phoneNumber: res.docs[a].data().phoneNumber,
                city: res.docs[a].data().city,
                delCharge: res.docs[a].data().delCharge
            })
        }
    }

    let total = 0.00;
    reportRes.data.forEach(element => {
        console.log(element.delCharge);
        if (element.delCharge != undefined)
            total = total + parseFloat(element.delCharge);
    });
    if (total != 0.00) {
        reportRes.data.push({
            CO_Number: 'Total',
            orderDate: '',
            pickupDate: '',
            name: '',
            item: '',
            delCharge: total
        })
    }

    return (reportRes)
}